let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kg6sH")).then(() => parcelRequire('koNv9'));